/**
 * JSON Schema for the playback entitlement request body object.
 *
 * http://json-schema.org/
 */
export default {
  id: "playbackEntitlementBody",
  type: "object",
  properties: {
    releasePids: {
      anyOf: [
        {
          type: "array",
          items: {
            type: "string"
          },
          minItems: 1
        },
        {
          type: "string"
        }
      ],
      required: true
    },
    protectionScheme: {
      type: "string",
      enum: ["widevine", "playready", "fairplay"],
      required: true
    }
  }
};
